import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BaseResizableComponent } from '@src/app/modules/base';

@Component({
  selector: 'contacts-value-text',
  templateUrl: './contacts-value-text.component.html',
  styleUrls: ['./contacts-value-text.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactsValueTextComponent extends BaseResizableComponent {
  @Input() loading: boolean = false;
}
